import { useState } from 'react';

import { Button } from '@components/button';
import { ButtonVariant } from '@components/button/button';
import { IconShare } from '@components/icons/share';
import { useScopedTranslate } from '@locale/translate';

import { JourneyForm } from 'api/journey-forms/requests';

import { useShareJourneyFormModal } from './share-journey-form';

export const ShareJourneyFormButton = ({
  journeyForm,
  variant = 'ghost',
}: {
  journeyForm?: JourneyForm;
  variant?: ButtonVariant;
}) => {
  const { t } = useScopedTranslate(locale);
  const shareModal = useShareJourneyFormModal();
  // When the shareModal is closed, the tooltip is triggered.
  // This is to prevent the tooltip from being shown when the modal is closed.
  const [justOpenedModal, setJustOpenedModal] = useState(false);

  return (
    <Button
      isDisabled={!journeyForm?.isPublished}
      iconLeft={<IconShare />}
      variant={variant}
      tooltip={
        justOpenedModal
          ? undefined
          : !journeyForm
          ? t('notSaved')
          : !journeyForm.isPublished
          ? t('notActive')
          : t('share')
      }
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();

        if (journeyForm) {
          (e.currentTarget as HTMLButtonElement).blur();
          setJustOpenedModal(true);
          shareModal({ journeyForm });
        }
      }}
      onMouseEnter={() => setJustOpenedModal(false)}
      onBlur={() => {
        if (justOpenedModal) {
          setJustOpenedModal(false);
        }
      }}
    />
  );
};

const locale = {
  en: {
    notSaved: 'Form needs to be named and saved before it can be shared',
    notActive: 'Form needs to be active before it can be shared',
    share: 'Share form submission link',
  },
};
